import { Module } from '@nestjs/common';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { CodeListModule } from './code-list/code-list.module';
import { PlantCapacityModule } from './plant-capacity/plant-capacity.module';
import { ResourceOperationEfficiencyModule } from './resource-operation-efficiency/resource-operation-efficiency.module';
import {appSettings} from '../../../config';
import { TypeOrmModule } from '@nestjs/typeorm';
import {resourceOperationEfficiency} from './resource-operation-efficiency/resource-operation-efficiency.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import {CodeList} from './code-list/code-list.entity'
import { PlantCapacity } from './plant-capacity/plant-capacity.entity';
import { ResourceOperationEfficiencyLog } from './resource-operation-efficiency/resource-op-efficiency-log.entity';
import { CodeListMainModule } from './code-list-main/code-list-main.module';
import { CodeListMain } from './code-list-main/code-list-main.entity';
import { CodeListMainItems } from './code-list-main/code-list-main-items.entity';
import { CodeListLog } from './code-list-main/code-list-log.entity';
import { QcClearanceInfo } from './qc-clearance-info/qc-clearance_info.entity';
import { QCClearanceModule } from './qc-clearance-info/qc-clearance-info.module';
import { FileUploadEntity } from './qc-clearance-info/file-upload.entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.planning_db,
      entities: [resourceOperationEfficiency,ResourceOperationEfficiencyLog,CodeList,PlantCapacity,CodeListMain,CodeListMainItems,CodeListLog,QcClearanceInfo,FileUploadEntity
      ],
      
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ),
    CodeListModule, PlantCapacityModule, ResourceOperationEfficiencyModule, CodeListMainModule,QCClearanceModule
  ],
  controllers: [AppController],
  providers: [AppService,ApplicationExceptionHandler],
})
export class AppModule {}
